import AccountSwitchPage from './AccountSwitchPage';

export default AccountSwitchPage;
